/**
 * Imprime un ticket desde el navegador.
 *
 * Está acá y no dentro de una pantalla porque lo usan dos: el POS al cobrar y
 * el detalle de una venta al reimprimir. Cada una tenía su propia copia y las
 * dos usaban `window.open`, que el navegador bloquea en cuanto el click no le
 * parece «directo»: una se rendía en silencio y la otra caía a un `alert` con
 * el ticket adentro.
 *
 * Va en un IFRAME OCULTO, que no depende del bloqueador de ventanas. En un
 * local que trabaja todo en línea, este es el camino por el que sale el papel
 * del cliente: no puede fallar sin decir nada.
 *
 * Devuelve false si el navegador no dejó imprimir, para que la pantalla lo
 * pueda decir (el ticket sigue en pantalla y se puede copiar).
 */
export function imprimirTicket(texto: string, titulo = 'Comprobante'): boolean {
  const marco = document.createElement('iframe')

  // Fuera de la vista pero NO `display:none`: un iframe sin caja no siempre
  // termina de cargar su documento, y entonces no hay nada que imprimir.
  marco.setAttribute(
    'style',
    'position:fixed; right:0; bottom:0; width:1px; height:1px; border:0; opacity:0;',
  )

  document.body.appendChild(marco)

  const doc = marco.contentDocument
  const ventana = marco.contentWindow

  if (!doc || !ventana) {
    marco.remove()
    return false
  }

  // El texto se escapa: el ticket lo arma el servidor, pero lleva nombres de
  // producto que carga un usuario, y un producto llamado «<script>» no puede
  // convertirse en código al imprimir.
  const escapado = texto.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

  doc.write(
    `<!doctype html><html lang="es-AR"><head><meta charset="utf-8">` +
      `<title>${escapado.length > 0 ? titulo : titulo}</title><style>` +
      `@page{margin:6mm}` +
      // Monoespaciada y respetando los espacios: el ticket viene alineado a
      // 48 caracteres, que es el ancho de una térmica de 80 mm.
      `body{font:12px/1.35 ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;` +
      `white-space:pre;margin:0}` +
      `</style></head><body>${escapado}</body></html>`,
  )

  doc.close()

  ventana.focus()
  ventana.print()

  // Se saca después de imprimir: el diálogo es modal en escritorio, pero en
  // algunos navegadores vuelve enseguida, así que se espera un momento.
  window.setTimeout(() => marco.remove(), 1000)

  return true
}
